import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVerySadEmotion = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path fill="#FFB03D" d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10" />
    <path
      fill="#00265D"
      stroke="#00265D"
      strokeWidth={0.043}
      d="M8.815 7.65a.33.33 0 0 1-.006.198.2.2 0 0 1-.11.101.6.6 0 0 1-.204.037 2 2 0 0 1-.274-.012q-.146-.014-.305-.036l-.012-.001a10 10 0 0 0-.336-.04 2 2 0 0 0-.632.016c-.19.044-.394.148-.593.267q-.15.09-.295.184l-.014.01q-.137.088-.264.165-.135.082-.25.133a.6.6 0 0 1-.203.058.2.2 0 0 1-.142-.043c-.038-.033-.069-.088-.087-.175-.074-.348.102-.758.42-1.104.317-.346.772-.622 1.245-.703a2.4 2.4 0 0 1 1.306.155c.389.168.682.442.756.79ZM11.332 7.65a.33.33 0 0 0 .007.198q.03.07.11.101a.6.6 0 0 0 .204.037q.122.004.273-.012.146-.014.306-.036l.012-.001q.166-.022.335-.04c.225-.02.447-.026.633.016.19.044.393.148.592.267q.151.09.296.184l.013.01q.138.088.265.165.134.082.248.133a.6.6 0 0 0 .204.058.2.2 0 0 0 .143-.043c.038-.033.068-.088.086-.175.074-.348-.102-.758-.42-1.104-.317-.346-.771-.622-1.245-.703a2.4 2.4 0 0 0-1.306.155c-.388.168-.682.442-.756.79Z"
    />
    <path
      fill="#00265D"
      stroke="#00265D"
      strokeLinecap="round"
      strokeWidth={1.176}
      d="M10 11.765c2.492 0 3.643 1.723 3.995 2.389.056.106-.038.218-.155.19-.662-.154-2.386-.52-3.84-.52s-3.177.366-3.84.52c-.116.028-.21-.084-.154-.19.352-.666 1.503-2.389 3.995-2.389Z"
    />
  </svg>
);
export default SvgVerySadEmotion;
